import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import NashaMuktLogo from "../../../assets/nasha_mukt_logo.svg";
import SmileLogo from "../../../assets/smile_baggery_logo.svg";
import NosLogo from "../../../assets/nos_logo.svg";
import PmAjayLogo from "../../../assets/pm_ajay.svg";
import NationalEmblem from "../../../assets/emblem.svg";

// The portal list the "Change" panel shows. SCW itself is omitted — this is the
// SCW admin, so there is nothing to switch to.
const PORTALS = [
  {
    icon: NashaMuktLogo,
    title: "NMBA",
    subtitle: "Nasha Mukt Bharat Abhiyaan",
    url: "https://nashamukt-admin.dosje.gov.in/login",
  },
  {
    icon: SmileLogo,
    title: "SMILE - Transgender",
    subtitle: "National Portal for Transgender Persons",
    url: "https://tg-admin.dosje.gov.in/login",
  },
  {
    icon: NosLogo,
    title: "NOS",
    subtitle: "National Overseas Scholarship",
    url: "https://nos-admin.dosje.gov.in/login",
  },
  {
    icon: SmileLogo,
    title: "SMILE - Beggary",
    subtitle: "National Portal for Persons Engaged in Begging",
    url: "https://smilebeggary-admin.dosje.gov.in/",
  },
  {
    icon: NationalEmblem,
    title: "E-Utthaan",
    subtitle: "Development Action Plan for Scheduled Cast",
    url: "",
  },
  {
    icon: NationalEmblem,
    title: "E-Anudaan",
    subtitle: "Description Text",
    url: "",
  },
  {
    icon: PmAjayLogo,
    title: "PM-AJAY",
    subtitle: "Pradhan Mantri Anusuchit Jaati Abhyuday Yojna",
    url: "https://pm-ajay.dosje.gov.in/auth/sign-in",
  },
  {
    icon: NationalEmblem,
    title: "NHAPOA",
    subtitle: "National Helpline Against Atrocities",
    url: "https://nhapoa-admin.dosje.gov.in",
  },
  {
    icon: SmileLogo,
    title: "Garima Greh",
    subtitle: "Shelter Home for Transgender Persons",
    url: "https://garimagreh.dosje.gov.in/",
  },
];

interface PortalPanelProps {
  open: boolean;
  onClose: () => void;
}

// Shared "Choose a portal to login" side panel used by the desktop banner and
// the mobile switch footer on all auth screens (login / forgot / reset).
const PortalPanel: React.FC<PortalPanelProps> = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center md:justify-end bg-black/20"
      onClick={onClose}
    >
      <div
        className="bg-[#FFF7F2] w-[90%] h-[90vh] md:w-[560px] md:h-[95vh] max-w-[90%] md:max-w-[560px] mr-0 md:mr-8 rounded-2xl shadow-2xl overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="shrink-0 bg-white p-5 flex items-center justify-between rounded-t-2xl">
          <h3 className="text-lg font-semibold text-[#1F2937]">
            Choose a portal to login
          </h3>
          <button
            type="button"
            aria-label="Close"
            onClick={onClose}
            className="text-red-600 hover:text-red-700"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto space-y-3 p-5">
          {PORTALS.map((portal) => (
            <div
              key={portal.title}
              onClick={() => {
                if (portal.url) {
                  window.location.href = portal.url;
                }
                onClose();
              }}
              className="flex items-center gap-3 rounded-xl p-3 cursor-pointer transition-shadow bg-white hover:shadow-sm border border-transparent hover:border-[#FF671F]"
            >
              <img
                loading="lazy"
                src={portal.icon}
                alt={`${portal.title}-logo`}
                className="h-11 w-11 object-contain shrink-0"
              />
              <div className="leading-tight">
                <p className="font-bold text-base text-[#FF671F]">
                  {portal.title}
                </p>
                <p className="text-sm text-[#1F2937] font-medium">
                  {portal.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PortalPanel;
